export default __webpack_public_path__ + "static/media/rewards-80px.dbfb7479.svg";